import { PushOptIn } from '../PushOptIn';
import { pushTopicLabels } from '../../lib/pushTopics';

/**
 * Opt-in for a push notification whenever the 15m model calls an actionable
 * over/under signal (recommendation !== SKIP) — see btc15-tracker-scheduled.ts.
 */
export function Btc15SignalOptIn() {
  return <PushOptIn topic="btc15" {...pushTopicLabels('btc15')} />;
}
